import { makeStyles } from '@material-ui/core'

import { getFont } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1.1fr repeat(14,0.2fr)',
    height: 67,
    alignItems: 'center'
  },
  paper: {
    borderRadius: 8,
    marginBottom: 12,
    backgroundColor: theme.palette.grey[300],
    boxShadow:
      '0px 1px 1px -1px rgb(0 0 0 / 16%), 0px 1px 1px 0px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 8%)',
    [theme.breakpoints.down('sm')]: {
      width: '1440px'
    }
  },
  dayContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2',
    width: '100%'
  },
  selectedDayContainer: {
    border: `2px solid ${theme.palette.grey[700]}`,
    borderRadius: 4
  },
  numberOfRooms: {
    position: 'absolute',
    zIndex: 1000,
    right: 8,
    bottom: 16,
    fontSize: 12
  },
  mainName: {
    display: 'flex',
    justifyContent: 'center',
    width: '290px',
    [theme.breakpoints.up('xl')]: {
      width: '100%'
    },
    [theme.breakpoints.down('xl')]: {
      width: '284px'
    },
    [theme.breakpoints.down('sm')]: {
      width: '408px'
    }
  },
  valueText: {
    fontSize: '12px',
    fontWeight: 700
  }
}))
export default useStyles
